export default "__VITE_ASSET__DKk6W5HI__"